import React from "react";
import { SxProps, Tab } from "@mui/material";
import { Link } from "react-router";
import { Theme } from "@mui/system";

type LinkTabProps = {
  label: string;
  to: string;
  selected: boolean;
  value: string;
  sx?: SxProps<Theme>
};

export default function LinkTab(props: LinkTabProps) {
  return <Tab disableRipple component={Link} aria-current={props.selected && "page"} {...props} />;
};
